import {Tag} from '@/profile-creation-wizard/components/for-creation/Tag';
import {ProfileCreationFunnelMode} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';
import {
    Address,
    WorkplacePreference,
    ExperienceLevel,
    FunctionalSkill,
    Language,
    ProfileCreationForm,
    PriceConfiguration,
} from '@/profile-creation-wizard/types';

export class CreationFormValidation {
    headlineValidationRules = {
        maxCharLimit: 50,
        minCharLimit: 5,
    };

    isHeadlineValid(headline: string | null): boolean {
        if (!headline) {
            return false;
        }
        const length = headline.trim().length;

        return length >= this.headlineValidationRules.minCharLimit && length <= this.headlineValidationRules.maxCharLimit;
    }

    isLocationValid(address: Address): boolean {
        if (!address) {
            return false;
        }

        if (!address.countryCode || !address.city || !address.lat || !address.lon) {
            return false;
        }

        if (!address.formattedAddress || address.formattedAddress.length > 100) {
            return false;
        }

        return true;
    }

    isWorkplacePreferenceValid(workplacePreference: WorkplacePreference | null): boolean {
        return !!workplacePreference;
    }

    isExperienceLevelValid(experienceLevel: ExperienceLevel | null): boolean {
        return !!experienceLevel;
    }

    areGlobalAndFunctionalSkillsValid(globalSkills: Tag[], functionalSkills: FunctionalSkill[]): boolean {
        return functionalSkills.length >= 4;
    }

    isTagsValid(tags: Tag[]): boolean {
        return tags.length >= 4;
    }

    isPriceValid(price: number, priceConfig: PriceConfiguration): boolean {
        return price >= priceConfig.minPriceAllowed && price <= priceConfig.maxPriceAllowed;
    }

    private hasLanguage(languages: Language[]): boolean {
        const mandatoryNativeLanguageExists = languages.some((language) => language.id === 0 && language.query !== null);
        return languages.length > 0 && mandatoryNativeLanguageExists;
    }

    private isPhoneValid(isStrategyFunnelMode: boolean, phone: string | null): boolean {
        return isStrategyFunnelMode ? phone !== null : true;
    }

    isValid(form: ProfileCreationForm, priceConfig: PriceConfiguration, funnelMode: string): boolean {
        const isStrategyFunnelMode = funnelMode == ProfileCreationFunnelMode.STRATEGY;
        return (
            form.familiesCategoriesEdition.hasCompleteSelection() &&
            this.isHeadlineValid(form.headline) &&
            this.isLocationValid(form.address) &&
            this.isExperienceLevelValid(form.experienceLevel) &&
            (this.isTagsValid(form.tags) || isStrategyFunnelMode) &&
            this.isPriceValid(form.price, priceConfig) &&
            this.hasLanguage(form.languages) &&
            this.isPhoneValid(isStrategyFunnelMode, form.phone) &&
            this.isWorkplacePreferenceValid(form.workPlacePreference)
        );
    }
}
